/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Refresh_Title7Inputs */

const en_svc_programmatic_seo_refresh_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freshness loops`)
};

const ar_svc_programmatic_seo_refresh_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حلقات التحديث`)
};

const bn_svc_programmatic_seo_refresh_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`তাজা রাখার লুপ`)
};

const de_svc_programmatic_seo_refresh_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frische-Schleifen`)
};

const es_svc_programmatic_seo_refresh_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciclos de frescura`)
};

const fr_svc_programmatic_seo_refresh_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boucles de fraîcheur`)
};

const pt_svc_programmatic_seo_refresh_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciclos de frescura`)
};

const zh_svc_programmatic_seo_refresh_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新鲜度循环`)
};

const tr_svc_programmatic_seo_refresh_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tazelik döngüleri`)
};

const ru_svc_programmatic_seo_refresh_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Циклы свежести`)
};

const pl_svc_programmatic_seo_refresh_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Refresh_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pętle świeżości`)
};

/**
* | output |
* | --- |
* | "Freshness loops" |
*
* @param {Svc_Programmatic_Seo_Refresh_Title7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_refresh_title7 = /** @type {((inputs?: Svc_Programmatic_Seo_Refresh_Title7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Refresh_Title7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_refresh_title7(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_refresh_title7(inputs)
	if (locale === "de") return de_svc_programmatic_seo_refresh_title7(inputs)
	if (locale === "es") return es_svc_programmatic_seo_refresh_title7(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_refresh_title7(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_refresh_title7(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_refresh_title7(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_refresh_title7(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_refresh_title7(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_refresh_title7(inputs)
	return en_svc_programmatic_seo_refresh_title7(inputs)
});
export { svc_programmatic_seo_refresh_title7 as "svc_programmatic-seo_REFRESH_title" }